// extracted by mini-css-extract-plugin
export default {"api-view":"APIView_api-view__KwrZ4"};